/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../routes/__root'
import { Route as IndexRouteImport } from './../../routes/index'
import { Route as AuthenticatedRouteImport } from './../../routes/_authenticated'
import { Route as AcquisitionRouteImport } from './../../routes/acquisition'
import { Route as ActRouteImport } from './../../routes/act'
import { Route as LoginRouteImport } from './../../routes/login'
import { Route as AuthenticatedStoreRouteRouteImport } from './../../routes/_authenticated/$store/route'
import { Route as AnalyticsSplatRouteImport } from './../../routes/analytics.$'
import { Route as AppointmentsSplatRouteImport } from './../../routes/appointments.$'
import { Route as ConversationsSplatRouteImport } from './../../routes/conversations.$'
import { Route as ImportsSplatRouteImport } from './../../routes/imports.$'
import { Route as OpportunitiesSplatRouteImport } from './../../routes/opportunities.$'
import { Route as OverviewSplatRouteImport } from './../../routes/overview.$'
import { Route as PurchasesSplatRouteImport } from './../../routes/purchases.$'
import { Route as SettingsSplatRouteImport } from './../../routes/settings.$'
import { Route as SourcesSplatRouteImport } from './../../routes/sources.$'
import { Route as AuthenticatedStoreIndexRouteImport } from './../../routes/_authenticated/$store/index'
import { Route as AuthenticatedStoreConversationsRouteRouteImport } from './../../routes/_authenticated/$store/conversations/route'
import { Route as AuthenticatedStoreOverviewRouteImport } from './../../routes/_authenticated/$store/overview'
import { Route as AuthenticatedStoreAnalyticsIndexRouteImport } from './../../routes/_authenticated/$store/analytics/index'
import { Route as AuthenticatedStoreAppointmentsIndexRouteImport } from './../../routes/_authenticated/$store/appointments/index'
import { Route as AuthenticatedStoreConversationsIndexRouteImport } from './../../routes/_authenticated/$store/conversations/index'
import { Route as AuthenticatedStoreConversationsConversationIdRouteImport } from './../../routes/_authenticated/$store/conversations/$conversationId'
import { Route as AuthenticatedStoreImportsIndexRouteImport } from './../../routes/_authenticated/$store/imports/index'
import { Route as AuthenticatedStoreImportsImportIdRouteImport } from './../../routes/_authenticated/$store/imports/$importId'
import { Route as AuthenticatedStoreOpportunitiesIndexRouteImport } from './../../routes/_authenticated/$store/opportunities/index'
import { Route as AuthenticatedStoreOpportunitiesOpportunityIdRouteImport } from './../../routes/_authenticated/$store/opportunities/$opportunityId'
import { Route as AuthenticatedStoreOpportunitiesNewRouteImport } from './../../routes/_authenticated/$store/opportunities/new'
import { Route as AuthenticatedStorePurchasesIndexRouteImport } from './../../routes/_authenticated/$store/purchases/index'
import { Route as AuthenticatedStoreSettingsIndexRouteImport } from './../../routes/_authenticated/$store/settings/index'
import { Route as AuthenticatedStoreSourcesIndexRouteImport } from './../../routes/_authenticated/$store/sources/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AcquisitionRoute = AcquisitionRouteImport.update({
  id: '/acquisition',
  path: '/acquisition',
  getParentRoute: () => rootRouteImport,
} as any)
const ActRoute = ActRouteImport.update({
  id: '/act',
  path: '/act',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedStoreRouteRoute = AuthenticatedStoreRouteRouteImport.update({
  id: '/$store',
  path: '/$store',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AnalyticsSplatRoute = AnalyticsSplatRouteImport.update({
  id: '/analytics/$',
  path: '/analytics/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentsSplatRoute = AppointmentsSplatRouteImport.update({
  id: '/appointments/$',
  path: '/appointments/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsSplatRoute = ConversationsSplatRouteImport.update({
  id: '/conversations/$',
  path: '/conversations/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsSplatRoute = ImportsSplatRouteImport.update({
  id: '/imports/$',
  path: '/imports/$',
  getParentRoute: () => rootRouteImport,
} as any)
const OpportunitiesSplatRoute = OpportunitiesSplatRouteImport.update({
  id: '/opportunities/$',
  path: '/opportunities/$',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewSplatRoute = OverviewSplatRouteImport.update({
  id: '/overview/$',
  path: '/overview/$',
  getParentRoute: () => rootRouteImport,
} as any)
const PurchasesSplatRoute = PurchasesSplatRouteImport.update({
  id: '/purchases/$',
  path: '/purchases/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSplatRoute = SettingsSplatRouteImport.update({
  id: '/settings/$',
  path: '/settings/$',
  getParentRoute: () => rootRouteImport,
} as any)
const SourcesSplatRoute = SourcesSplatRouteImport.update({
  id: '/sources/$',
  path: '/sources/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedStoreIndexRoute = AuthenticatedStoreIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedStoreRouteRoute,
} as any)
const AuthenticatedStoreConversationsRouteRoute =
  AuthenticatedStoreConversationsRouteRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreOverviewRoute =
  AuthenticatedStoreOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreAnalyticsIndexRoute =
  AuthenticatedStoreAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreAppointmentsIndexRoute =
  AuthenticatedStoreAppointmentsIndexRouteImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreConversationsIndexRoute =
  AuthenticatedStoreConversationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedStoreConversationsRouteRoute,
  } as any)
const AuthenticatedStoreConversationsConversationIdRoute =
  AuthenticatedStoreConversationsConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => AuthenticatedStoreConversationsRouteRoute,
  } as any)
const AuthenticatedStoreImportsIndexRoute =
  AuthenticatedStoreImportsIndexRouteImport.update({
    id: '/imports/',
    path: '/imports/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreImportsImportIdRoute =
  AuthenticatedStoreImportsImportIdRouteImport.update({
    id: '/imports/$importId',
    path: '/imports/$importId',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreOpportunitiesIndexRoute =
  AuthenticatedStoreOpportunitiesIndexRouteImport.update({
    id: '/opportunities/',
    path: '/opportunities/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreOpportunitiesOpportunityIdRoute =
  AuthenticatedStoreOpportunitiesOpportunityIdRouteImport.update({
    id: '/opportunities/$opportunityId',
    path: '/opportunities/$opportunityId',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreOpportunitiesNewRoute =
  AuthenticatedStoreOpportunitiesNewRouteImport.update({
    id: '/opportunities/new',
    path: '/opportunities/new',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStorePurchasesIndexRoute =
  AuthenticatedStorePurchasesIndexRouteImport.update({
    id: '/purchases/',
    path: '/purchases/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreSettingsIndexRoute =
  AuthenticatedStoreSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)
const AuthenticatedStoreSourcesIndexRoute =
  AuthenticatedStoreSourcesIndexRouteImport.update({
    id: '/sources/',
    path: '/sources/',
    getParentRoute: () => AuthenticatedStoreRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/acquisition': typeof AcquisitionRoute
  '/act': typeof ActRoute
  '/login': typeof LoginRoute
  '/$store': typeof AuthenticatedStoreRouteRouteWithChildren
  '/analytics/$': typeof AnalyticsSplatRoute
  '/appointments/$': typeof AppointmentsSplatRoute
  '/conversations/$': typeof ConversationsSplatRoute
  '/imports/$': typeof ImportsSplatRoute
  '/opportunities/$': typeof OpportunitiesSplatRoute
  '/overview/$': typeof OverviewSplatRoute
  '/purchases/$': typeof PurchasesSplatRoute
  '/settings/$': typeof SettingsSplatRoute
  '/sources/$': typeof SourcesSplatRoute
  '/$store/conversations': typeof AuthenticatedStoreConversationsRouteRouteWithChildren
  '/$store/overview': typeof AuthenticatedStoreOverviewRoute
  '/$store/': typeof AuthenticatedStoreIndexRoute
  '/$store/conversations/$conversationId': typeof AuthenticatedStoreConversationsConversationIdRoute
  '/$store/imports/$importId': typeof AuthenticatedStoreImportsImportIdRoute
  '/$store/opportunities/$opportunityId': typeof AuthenticatedStoreOpportunitiesOpportunityIdRoute
  '/$store/opportunities/new': typeof AuthenticatedStoreOpportunitiesNewRoute
  '/$store/analytics/': typeof AuthenticatedStoreAnalyticsIndexRoute
  '/$store/appointments/': typeof AuthenticatedStoreAppointmentsIndexRoute
  '/$store/conversations/': typeof AuthenticatedStoreConversationsIndexRoute
  '/$store/imports/': typeof AuthenticatedStoreImportsIndexRoute
  '/$store/opportunities/': typeof AuthenticatedStoreOpportunitiesIndexRoute
  '/$store/purchases/': typeof AuthenticatedStorePurchasesIndexRoute
  '/$store/settings/': typeof AuthenticatedStoreSettingsIndexRoute
  '/$store/sources/': typeof AuthenticatedStoreSourcesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/acquisition': typeof AcquisitionRoute
  '/act': typeof ActRoute
  '/login': typeof LoginRoute
  '/analytics/$': typeof AnalyticsSplatRoute
  '/appointments/$': typeof AppointmentsSplatRoute
  '/conversations/$': typeof ConversationsSplatRoute
  '/imports/$': typeof ImportsSplatRoute
  '/opportunities/$': typeof OpportunitiesSplatRoute
  '/overview/$': typeof OverviewSplatRoute
  '/purchases/$': typeof PurchasesSplatRoute
  '/settings/$': typeof SettingsSplatRoute
  '/sources/$': typeof SourcesSplatRoute
  '/$store/overview': typeof AuthenticatedStoreOverviewRoute
  '/$store': typeof AuthenticatedStoreIndexRoute
  '/$store/conversations/$conversationId': typeof AuthenticatedStoreConversationsConversationIdRoute
  '/$store/imports/$importId': typeof AuthenticatedStoreImportsImportIdRoute
  '/$store/opportunities/$opportunityId': typeof AuthenticatedStoreOpportunitiesOpportunityIdRoute
  '/$store/opportunities/new': typeof AuthenticatedStoreOpportunitiesNewRoute
  '/$store/analytics': typeof AuthenticatedStoreAnalyticsIndexRoute
  '/$store/appointments': typeof AuthenticatedStoreAppointmentsIndexRoute
  '/$store/conversations': typeof AuthenticatedStoreConversationsIndexRoute
  '/$store/imports': typeof AuthenticatedStoreImportsIndexRoute
  '/$store/opportunities': typeof AuthenticatedStoreOpportunitiesIndexRoute
  '/$store/purchases': typeof AuthenticatedStorePurchasesIndexRoute
  '/$store/settings': typeof AuthenticatedStoreSettingsIndexRoute
  '/$store/sources': typeof AuthenticatedStoreSourcesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/acquisition': typeof AcquisitionRoute
  '/act': typeof ActRoute
  '/login': typeof LoginRoute
  '/_authenticated/$store': typeof AuthenticatedStoreRouteRouteWithChildren
  '/analytics/$': typeof AnalyticsSplatRoute
  '/appointments/$': typeof AppointmentsSplatRoute
  '/conversations/$': typeof ConversationsSplatRoute
  '/imports/$': typeof ImportsSplatRoute
  '/opportunities/$': typeof OpportunitiesSplatRoute
  '/overview/$': typeof OverviewSplatRoute
  '/purchases/$': typeof PurchasesSplatRoute
  '/settings/$': typeof SettingsSplatRoute
  '/sources/$': typeof SourcesSplatRoute
  '/_authenticated/$store/conversations': typeof AuthenticatedStoreConversationsRouteRouteWithChildren
  '/_authenticated/$store/overview': typeof AuthenticatedStoreOverviewRoute
  '/_authenticated/$store/': typeof AuthenticatedStoreIndexRoute
  '/_authenticated/$store/conversations/$conversationId': typeof AuthenticatedStoreConversationsConversationIdRoute
  '/_authenticated/$store/imports/$importId': typeof AuthenticatedStoreImportsImportIdRoute
  '/_authenticated/$store/opportunities/$opportunityId': typeof AuthenticatedStoreOpportunitiesOpportunityIdRoute
  '/_authenticated/$store/opportunities/new': typeof AuthenticatedStoreOpportunitiesNewRoute
  '/_authenticated/$store/analytics/': typeof AuthenticatedStoreAnalyticsIndexRoute
  '/_authenticated/$store/appointments/': typeof AuthenticatedStoreAppointmentsIndexRoute
  '/_authenticated/$store/conversations/': typeof AuthenticatedStoreConversationsIndexRoute
  '/_authenticated/$store/imports/': typeof AuthenticatedStoreImportsIndexRoute
  '/_authenticated/$store/opportunities/': typeof AuthenticatedStoreOpportunitiesIndexRoute
  '/_authenticated/$store/purchases/': typeof AuthenticatedStorePurchasesIndexRoute
  '/_authenticated/$store/settings/': typeof AuthenticatedStoreSettingsIndexRoute
  '/_authenticated/$store/sources/': typeof AuthenticatedStoreSourcesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/acquisition'
    | '/act'
    | '/login'
    | '/$store'
    | '/analytics/$'
    | '/appointments/$'
    | '/conversations/$'
    | '/imports/$'
    | '/opportunities/$'
    | '/overview/$'
    | '/purchases/$'
    | '/settings/$'
    | '/sources/$'
    | '/$store/conversations'
    | '/$store/overview'
    | '/$store/'
    | '/$store/conversations/$conversationId'
    | '/$store/imports/$importId'
    | '/$store/opportunities/$opportunityId'
    | '/$store/opportunities/new'
    | '/$store/analytics/'
    | '/$store/appointments/'
    | '/$store/conversations/'
    | '/$store/imports/'
    | '/$store/opportunities/'
    | '/$store/purchases/'
    | '/$store/settings/'
    | '/$store/sources/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/acquisition'
    | '/act'
    | '/login'
    | '/analytics/$'
    | '/appointments/$'
    | '/conversations/$'
    | '/imports/$'
    | '/opportunities/$'
    | '/overview/$'
    | '/purchases/$'
    | '/settings/$'
    | '/sources/$'
    | '/$store/overview'
    | '/$store'
    | '/$store/conversations/$conversationId'
    | '/$store/imports/$importId'
    | '/$store/opportunities/$opportunityId'
    | '/$store/opportunities/new'
    | '/$store/analytics'
    | '/$store/appointments'
    | '/$store/conversations'
    | '/$store/imports'
    | '/$store/opportunities'
    | '/$store/purchases'
    | '/$store/settings'
    | '/$store/sources'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/acquisition'
    | '/act'
    | '/login'
    | '/_authenticated/$store'
    | '/analytics/$'
    | '/appointments/$'
    | '/conversations/$'
    | '/imports/$'
    | '/opportunities/$'
    | '/overview/$'
    | '/purchases/$'
    | '/settings/$'
    | '/sources/$'
    | '/_authenticated/$store/conversations'
    | '/_authenticated/$store/overview'
    | '/_authenticated/$store/'
    | '/_authenticated/$store/conversations/$conversationId'
    | '/_authenticated/$store/imports/$importId'
    | '/_authenticated/$store/opportunities/$opportunityId'
    | '/_authenticated/$store/opportunities/new'
    | '/_authenticated/$store/analytics/'
    | '/_authenticated/$store/appointments/'
    | '/_authenticated/$store/conversations/'
    | '/_authenticated/$store/imports/'
    | '/_authenticated/$store/opportunities/'
    | '/_authenticated/$store/purchases/'
    | '/_authenticated/$store/settings/'
    | '/_authenticated/$store/sources/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcquisitionRoute: typeof AcquisitionRoute
  ActRoute: typeof ActRoute
  LoginRoute: typeof LoginRoute
  AnalyticsSplatRoute: typeof AnalyticsSplatRoute
  AppointmentsSplatRoute: typeof AppointmentsSplatRoute
  ConversationsSplatRoute: typeof ConversationsSplatRoute
  ImportsSplatRoute: typeof ImportsSplatRoute
  OpportunitiesSplatRoute: typeof OpportunitiesSplatRoute
  OverviewSplatRoute: typeof OverviewSplatRoute
  PurchasesSplatRoute: typeof PurchasesSplatRoute
  SettingsSplatRoute: typeof SettingsSplatRoute
  SourcesSplatRoute: typeof SourcesSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/acquisition': {
      id: '/acquisition'
      path: '/acquisition'
      fullPath: '/acquisition'
      preLoaderRoute: typeof AcquisitionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/act': {
      id: '/act'
      path: '/act'
      fullPath: '/act'
      preLoaderRoute: typeof ActRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$store': {
      id: '/_authenticated/$store'
      path: '/$store'
      fullPath: '/$store'
      preLoaderRoute: typeof AuthenticatedStoreRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/analytics/$': {
      id: '/analytics/$'
      path: '/analytics/$'
      fullPath: '/analytics/$'
      preLoaderRoute: typeof AnalyticsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointments/$': {
      id: '/appointments/$'
      path: '/appointments/$'
      fullPath: '/appointments/$'
      preLoaderRoute: typeof AppointmentsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations/$': {
      id: '/conversations/$'
      path: '/conversations/$'
      fullPath: '/conversations/$'
      preLoaderRoute: typeof ConversationsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports/$': {
      id: '/imports/$'
      path: '/imports/$'
      fullPath: '/imports/$'
      preLoaderRoute: typeof ImportsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/opportunities/$': {
      id: '/opportunities/$'
      path: '/opportunities/$'
      fullPath: '/opportunities/$'
      preLoaderRoute: typeof OpportunitiesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview/$': {
      id: '/overview/$'
      path: '/overview/$'
      fullPath: '/overview/$'
      preLoaderRoute: typeof OverviewSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/purchases/$': {
      id: '/purchases/$'
      path: '/purchases/$'
      fullPath: '/purchases/$'
      preLoaderRoute: typeof PurchasesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/$': {
      id: '/settings/$'
      path: '/settings/$'
      fullPath: '/settings/$'
      preLoaderRoute: typeof SettingsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sources/$': {
      id: '/sources/$'
      path: '/sources/$'
      fullPath: '/sources/$'
      preLoaderRoute: typeof SourcesSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/$store/': {
      id: '/_authenticated/$store/'
      path: '/'
      fullPath: '/$store/'
      preLoaderRoute: typeof AuthenticatedStoreIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/conversations': {
      id: '/_authenticated/$store/conversations'
      path: '/conversations'
      fullPath: '/$store/conversations'
      preLoaderRoute: typeof AuthenticatedStoreConversationsRouteRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/overview': {
      id: '/_authenticated/$store/overview'
      path: '/overview'
      fullPath: '/$store/overview'
      preLoaderRoute: typeof AuthenticatedStoreOverviewRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/analytics/': {
      id: '/_authenticated/$store/analytics/'
      path: '/analytics'
      fullPath: '/$store/analytics/'
      preLoaderRoute: typeof AuthenticatedStoreAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/appointments/': {
      id: '/_authenticated/$store/appointments/'
      path: '/appointments'
      fullPath: '/$store/appointments/'
      preLoaderRoute: typeof AuthenticatedStoreAppointmentsIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/conversations/': {
      id: '/_authenticated/$store/conversations/'
      path: '/'
      fullPath: '/$store/conversations/'
      preLoaderRoute: typeof AuthenticatedStoreConversationsIndexRouteImport
      parentRoute: typeof AuthenticatedStoreConversationsRouteRoute
    }
    '/_authenticated/$store/conversations/$conversationId': {
      id: '/_authenticated/$store/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/$store/conversations/$conversationId'
      preLoaderRoute: typeof AuthenticatedStoreConversationsConversationIdRouteImport
      parentRoute: typeof AuthenticatedStoreConversationsRouteRoute
    }
    '/_authenticated/$store/imports/': {
      id: '/_authenticated/$store/imports/'
      path: '/imports'
      fullPath: '/$store/imports/'
      preLoaderRoute: typeof AuthenticatedStoreImportsIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/imports/$importId': {
      id: '/_authenticated/$store/imports/$importId'
      path: '/imports/$importId'
      fullPath: '/$store/imports/$importId'
      preLoaderRoute: typeof AuthenticatedStoreImportsImportIdRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/opportunities/': {
      id: '/_authenticated/$store/opportunities/'
      path: '/opportunities'
      fullPath: '/$store/opportunities/'
      preLoaderRoute: typeof AuthenticatedStoreOpportunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/opportunities/$opportunityId': {
      id: '/_authenticated/$store/opportunities/$opportunityId'
      path: '/opportunities/$opportunityId'
      fullPath: '/$store/opportunities/$opportunityId'
      preLoaderRoute: typeof AuthenticatedStoreOpportunitiesOpportunityIdRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/opportunities/new': {
      id: '/_authenticated/$store/opportunities/new'
      path: '/opportunities/new'
      fullPath: '/$store/opportunities/new'
      preLoaderRoute: typeof AuthenticatedStoreOpportunitiesNewRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/purchases/': {
      id: '/_authenticated/$store/purchases/'
      path: '/purchases'
      fullPath: '/$store/purchases/'
      preLoaderRoute: typeof AuthenticatedStorePurchasesIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/settings/': {
      id: '/_authenticated/$store/settings/'
      path: '/settings'
      fullPath: '/$store/settings/'
      preLoaderRoute: typeof AuthenticatedStoreSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
    '/_authenticated/$store/sources/': {
      id: '/_authenticated/$store/sources/'
      path: '/sources'
      fullPath: '/$store/sources/'
      preLoaderRoute: typeof AuthenticatedStoreSourcesIndexRouteImport
      parentRoute: typeof AuthenticatedStoreRouteRoute
    }
  }
}

interface AuthenticatedStoreConversationsRouteRouteChildren {
  AuthenticatedStoreConversationsConversationIdRoute: typeof AuthenticatedStoreConversationsConversationIdRoute
  AuthenticatedStoreConversationsIndexRoute: typeof AuthenticatedStoreConversationsIndexRoute
}

const AuthenticatedStoreConversationsRouteRouteChildren: AuthenticatedStoreConversationsRouteRouteChildren =
  {
    AuthenticatedStoreConversationsConversationIdRoute:
      AuthenticatedStoreConversationsConversationIdRoute,
    AuthenticatedStoreConversationsIndexRoute:
      AuthenticatedStoreConversationsIndexRoute,
  }

const AuthenticatedStoreConversationsRouteRouteWithChildren =
  AuthenticatedStoreConversationsRouteRoute._addFileChildren(
    AuthenticatedStoreConversationsRouteRouteChildren,
  )

interface AuthenticatedStoreRouteRouteChildren {
  AuthenticatedStoreConversationsRouteRoute: typeof AuthenticatedStoreConversationsRouteRouteWithChildren
  AuthenticatedStoreOverviewRoute: typeof AuthenticatedStoreOverviewRoute
  AuthenticatedStoreIndexRoute: typeof AuthenticatedStoreIndexRoute
  AuthenticatedStoreImportsImportIdRoute: typeof AuthenticatedStoreImportsImportIdRoute
  AuthenticatedStoreOpportunitiesOpportunityIdRoute: typeof AuthenticatedStoreOpportunitiesOpportunityIdRoute
  AuthenticatedStoreOpportunitiesNewRoute: typeof AuthenticatedStoreOpportunitiesNewRoute
  AuthenticatedStoreAnalyticsIndexRoute: typeof AuthenticatedStoreAnalyticsIndexRoute
  AuthenticatedStoreAppointmentsIndexRoute: typeof AuthenticatedStoreAppointmentsIndexRoute
  AuthenticatedStoreImportsIndexRoute: typeof AuthenticatedStoreImportsIndexRoute
  AuthenticatedStoreOpportunitiesIndexRoute: typeof AuthenticatedStoreOpportunitiesIndexRoute
  AuthenticatedStorePurchasesIndexRoute: typeof AuthenticatedStorePurchasesIndexRoute
  AuthenticatedStoreSettingsIndexRoute: typeof AuthenticatedStoreSettingsIndexRoute
  AuthenticatedStoreSourcesIndexRoute: typeof AuthenticatedStoreSourcesIndexRoute
}

const AuthenticatedStoreRouteRouteChildren: AuthenticatedStoreRouteRouteChildren =
  {
    AuthenticatedStoreConversationsRouteRoute:
      AuthenticatedStoreConversationsRouteRouteWithChildren,
    AuthenticatedStoreOverviewRoute: AuthenticatedStoreOverviewRoute,
    AuthenticatedStoreIndexRoute: AuthenticatedStoreIndexRoute,
    AuthenticatedStoreImportsImportIdRoute:
      AuthenticatedStoreImportsImportIdRoute,
    AuthenticatedStoreOpportunitiesOpportunityIdRoute:
      AuthenticatedStoreOpportunitiesOpportunityIdRoute,
    AuthenticatedStoreOpportunitiesNewRoute:
      AuthenticatedStoreOpportunitiesNewRoute,
    AuthenticatedStoreAnalyticsIndexRoute:
      AuthenticatedStoreAnalyticsIndexRoute,
    AuthenticatedStoreAppointmentsIndexRoute:
      AuthenticatedStoreAppointmentsIndexRoute,
    AuthenticatedStoreImportsIndexRoute: AuthenticatedStoreImportsIndexRoute,
    AuthenticatedStoreOpportunitiesIndexRoute:
      AuthenticatedStoreOpportunitiesIndexRoute,
    AuthenticatedStorePurchasesIndexRoute:
      AuthenticatedStorePurchasesIndexRoute,
    AuthenticatedStoreSettingsIndexRoute: AuthenticatedStoreSettingsIndexRoute,
    AuthenticatedStoreSourcesIndexRoute: AuthenticatedStoreSourcesIndexRoute,
  }

const AuthenticatedStoreRouteRouteWithChildren =
  AuthenticatedStoreRouteRoute._addFileChildren(
    AuthenticatedStoreRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedStoreRouteRoute: typeof AuthenticatedStoreRouteRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedStoreRouteRoute: AuthenticatedStoreRouteRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcquisitionRoute: AcquisitionRoute,
  ActRoute: ActRoute,
  LoginRoute: LoginRoute,
  AnalyticsSplatRoute: AnalyticsSplatRoute,
  AppointmentsSplatRoute: AppointmentsSplatRoute,
  ConversationsSplatRoute: ConversationsSplatRoute,
  ImportsSplatRoute: ImportsSplatRoute,
  OpportunitiesSplatRoute: OpportunitiesSplatRoute,
  OverviewSplatRoute: OverviewSplatRoute,
  PurchasesSplatRoute: PurchasesSplatRoute,
  SettingsSplatRoute: SettingsSplatRoute,
  SourcesSplatRoute: SourcesSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
